import React, {useState} from "react";
import {Button, Card, Checkbox, Col, Divider, Drawer, Image, message, Row, Space, Spin} from "antd";
import {useMount} from "ahooks";
import {VscsApi} from "../../services/VscsApi";
import TableLongText from "../../containers/TableLongText";
import DefaultVideoCard from "../../components/common/DefaultVideoCard";
import {ApiService} from "../../services/ApiService";

const MAX_COUNT = 12
var USER = {}
const VscsCamerasPage = () => {

    const [loading, setLoading] = useState(false)
    const [drawerVisible, setDrawerVisible] = useState(false)
    const [venues, setVenues] = useState([])
    const [selectedCameras, setSelectedCameras] = useState([])
    const [cachedSelectedCameras, setCachedSelectedCameras] = useState([])

    useMount(() => {
        ApiService.user.current().onSuccess(user => {
            USER = user
            var cachedCamerasJson = window.localStorage.getItem("VSCS_CAMERAS_" + user.username)
            var cachedCameras = []
            try {
                cachedCameras = cachedCamerasJson ? JSON.parse(cachedCamerasJson) : []
            } catch (e) {
            }


            VscsApi.venues(null, "-1", 1)
                .onSuccess(data => {
                    setVenues([...data])

                    let selectedCameras = []
                    for (let i = 0; i < data.length; i++) {
                        const venue = data[i]
                        const cameras = venue.properties?.cameras ?? []
                        for (let j = 0; j < cameras.length; j++) {
                            const camera = cameras[j]
                            if (!camera.hlsUrl) {
                                continue
                            }
                            if (selectedCameras.length == MAX_COUNT) {
                                break
                            }
                            selectedCameras.push(camera)
                        }
                    }
                    if (cachedCameras.length > 0) {
                        selectedCameras = cachedCameras
                    }
                    setCachedSelectedCameras([...selectedCameras])
                    setSelectedCameras([...selectedCameras])
                })
        })

    })

    const handleCameraChange = (checked, camera) => {
        if (checked) {
            if (cachedSelectedCameras.length === MAX_COUNT) {
                message.error("最多可同时选择" + MAX_COUNT + "个摄像机")
                return false;
            } else {
                setCachedSelectedCameras([camera, ...cachedSelectedCameras])
            }
        } else {
            let selected = [...cachedSelectedCameras]
            let index = selected.findIndex(c => c.guid === camera.guid)
            if (index > -1) {
                selected.splice(index, 1)
                setCachedSelectedCameras([...selected])
            }
        }
    }

    const handleDrawerClose = () => {
        setDrawerVisible(false)
        setSelectedCameras([...cachedSelectedCameras])
        window.localStorage.setItem("VSCS_CAMERAS_" + USER.username, JSON.stringify(cachedSelectedCameras))
    }

    const handleReload = () => {
        setLoading(true)
        setSelectedCameras([])
        setTimeout(() => {
            setSelectedCameras([...cachedSelectedCameras])
            setLoading(false)
        }, 1000)
    }

    return (
        <>
            <Card>
                <Spin spinning={loading}>
                    <Row>
                        {
                            selectedCameras.map(c => <Col span={6}>
                                <DefaultVideoCard
                                    key={c.guid}
                                    src={c.hlsUrl}
                                    title={c.name}
                                />
                            </Col>)
                        }
                    </Row>
                    <Row justify="end" style={{marginTop: 5}}>
                        <Button onClick={() => handleReload()}>重新加载</Button>
                        <Button onClick={() => setDrawerVisible(true)}>配置相机</Button>
                    </Row>
                </Spin>
            </Card>
            <Drawer
                title={"选择摄像机（" + cachedSelectedCameras.length + "/" + MAX_COUNT + "）"}
                placement="right"
                closable={true}
                onClose={() => handleDrawerClose()}
                visible={drawerVisible}
                key="camera-select-drawer"
            >
                <Space direction="vertical" split={<Divider style={{margin: "5px 0"}}/>}>
                    {
                        venues.map(venue => <Space direction="vertical">
                            <Space key={venue.guid}>
                                <Image src={venue.imageUrl} width={60} height={60}/>
                                <div>
                                    <TableLongText style={{marginBottom: 0}} text={venue.name}/>
                                    <TableLongText style={{marginBottom: 0}} text={venue.properties?.religion}/>
                                    <TableLongText style={{marginBottom: 0}} text={venue.properties?.region?.name}/>
                                </div>
                            </Space>
                            {
                                venue.properties?.cameras?.filter(camera => camera.hlsUrl).map(camera => <>
                                    <Checkbox
                                        checked={cachedSelectedCameras.findIndex(c => c.guid === camera.guid) > -1}
                                        onChange={e => handleCameraChange(e.target.checked, camera)}
                                    >{camera.name}</Checkbox>
                                </>)
                            }
                        </Space>)
                    }
                </Space>
            </Drawer>
        </>
    )
}

export default VscsCamerasPage